import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ITraceabilityCommandPort,
  UpdatePrioritizationRequest
} from '@domain/service/traceability/traceability-command.port';
import { TraceabilityService } from '../services/traceability.service';

@Injectable({
  providedIn: 'root'
})
export class TraceabilityCommandAdapter implements ITraceabilityCommandPort {
  private readonly traceabilityService = inject(TraceabilityService);

  updatePrioritization(
    lgCode: string,
    request: UpdatePrioritizationRequest
  ): Observable<void> {
    return this.traceabilityService.updatePrioritization(lgCode, request);
  }
}
